<template>
  <div id="app">
    <div v-if="wxOAuthProcessing" class="init-loading">
      <div class="init-spinner">
        <i class="el-icon-loading" />
        <p>正在加载...</p>
      </div>
    </div>
    <router-view v-else />
  </div>
</template>

<script>

export default {
  name: 'App',

  data() {
    return {
      wxOAuthProcessing: false
    }
  },

  created() {
    // OAuth回调时立即标记，防止router-view渲染主页面造成闪烁
    if (window.location.search.includes('code=')) {
      this.wxOAuthProcessing = true
    }
    this._handleWxOAuthCallback()
  },

  methods: {
    /**
     * 处理企业微信OAuth2回调
     *
     * 企业微信静默授权（snsapi_base）流程：
     *   1. 前端检测到企业微信环境 + 无code → 跳转OAuth2授权
     *   2. 企业微信回调：http://wl.pepco.com.cn/?code=xxx&state=yyy
     *   3. 本方法提取code→存入sessionStorage→恢复原始hash→清理URL
     *   4. Vue Router重新导航到原始页面 → review.vue的autoDetectWxUser读取code
     */
    _handleWxOAuthCallback() {
      console.log('[VMD-OAuth] App.vue _handleWxOAuthCallback 开始, location.search:', window.location.search, 'location.hash:', window.location.hash, 'location.href:', window.location.href)
      const searchMatch = window.location.search.match(/[?&]code=([^&]+)/)
      if (!searchMatch) {
        console.log('[VMD-OAuth] App.vue _handleWxOAuthCallback: URL中无code参数，跳过')
        return // 无回调，跳过
      }

      const code = decodeURIComponent(searchMatch[1])
      console.log('[VMD-OAuth] App.vue: 提取到code:', code.substring(0, 10) + '...')
      // 存入sessionStorage，供review.vue的autoDetectWxUser读取
      sessionStorage.setItem('vmd_oauth_code', code)
      console.log('[VMD-OAuth] App.vue: code已存入sessionStorage')

      // 从state参数解码目标路由（格式: /vmd/review__nonce）
      const urlParams = new URLSearchParams(window.location.search)
      const stateParam = urlParams.get('state') || ''
      const stateParts = stateParam.split('__')
      let targetRoute = null
      if (stateParts.length >= 2) {
        targetRoute = '#' + stateParts[0] // 还原hash: '/vmd/review' → '#/vmd/review'
        console.log('[VMD-OAuth] App.vue: 从state解码目标路由→', targetRoute)
      } else {
        console.log('[VMD-OAuth] App.vue: state参数无法解析:', stateParam)
      }

      // 备选：从sessionStorage恢复hash路由
      const savedHash = sessionStorage.getItem('vmd_oauth_hash')
      console.log('[VMD-OAuth] App.vue: sessionStorage中savedHash→', savedHash)
      sessionStorage.removeItem('vmd_oauth_hash')

      if (!targetRoute) {
        targetRoute = savedHash || '#/'
        console.log('[VMD-OAuth] App.vue: 回退使用sessionStorage或默认路由→', targetRoute)
      }

      // 清理URL → 使用 location.replace 做干净重定向（比 $router.replace 更可靠，
      //       因为 created() 阶段 Vue Router 可能尚未完成初始化）
      const newUrl = window.location.origin + window.location.pathname + targetRoute
      console.log('[VMD-OAuth] App.vue: 🚀 location.replace →', newUrl)
      // code 已存入 sessionStorage，跨页面重载不会丢失
      window.location.replace(newUrl)
    }
  }
}
</script>

<style lang='scss'>
@use '@/styles/responsive.scss';

/* OAuth回调加载遮罩 — 防止主页面闪烁 */
.init-loading {
  position: fixed;
  inset: 0;
  background: #f5f7fa;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.init-spinner {
  text-align: center;
  i {
    font-size: 40px;
    color: #409eff;
  }
  p {
    margin-top: 16px;
    font-size: 14px;
    color: #909399;
  }
}

/* 强制首页视频在最底层 */
#vd {
  z-index: -9999 !important;
  position: fixed !important;
  pointer-events: none !important;
}

/* 强制移动端菜单在最顶层 */
@media screen and (max-width: 768px) {
  .mobile-nav {
    z-index: 99999 !important;
  }
  .menu-overlay {
    z-index: 9999 !important;
  }
  .side-menu {
    z-index: 10000 !important;
  }
}

.el-table::after,.el-table::before {
  display: none;
}
.el-image__error{
  font-size: 40px !important;
}
#app,html,body{
  padding:0px;
  margin: 0px;
  min-width:320px;
  height:100%;
  width: 100%;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

/* 全局响应式样式 */
@media screen and (max-width: 768px) {
  #app, html, body {
    min-height: 100vh;
    min-height: 100dvh;
    overflow-x: hidden;
  }
  
  /* 移动端图片最大宽度 */
  img {
    max-width: 100%;
    height: auto;
  }
  
  /* 移动端弹性盒 */
  .el-image {
    max-width: 100%;
  }
}

*{
  font-family:pepco;
  font-weight: 200;
  box-sizing: border-box;
}

*{
    scrollbar-color: rgba(144, 147, 153, 0.3) transparent;
    scrollbar-width: thin;
}
*::-webkit-scrollbar {
    width:10px;
    height: 6px;
}
*::-webkit-scrollbar-button {
    display: none;
}
*::-webkit-scrollbar-track {
    background: transparent;
}
*::-webkit-scrollbar-track-piece {
    background-color: transparent;
}
*::-webkit-scrollbar-thumb {
    background: rgba(144, 147, 153, 0.2);
    cursor: pointer;
    border-radius: 10px;
}
*::-webkit-scrollbar-thumb:hover {
    background: rgba(144, 147, 153, 0.5);
    cursor: pointer;
}
*::-webkit-scrollbar-corner {
    display: none;
}
*::-webkit-resizer {
    display: none;
}

@font-face{
  font-family: 'pepco';
  src: url(./assets/font2/yuanti2.eot) format('embedded-opentype'),
       url(./assets/font2/yuanti2.ttf) format('truetype');     
  font-weight: 500;
}

/* Element UI 响应式调整 */
@media screen and (max-width: 768px) {
  .el-carousel__item h3 {
    font-size: 14px !important;
  }
  
  .el-message {
    min-width: 280px !important;
  }
  
  .el-dialog {
    width: 90% !important;
    max-width: 500px;
  }
  
  /* Element UI 图片响应式 */
  .el-image {
    width: 100% !important;
    max-width: 100%;
  }
  
  /* 禁止文字选中放大 */
  * {
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: transparent;
  }
  
  /* 移动端优化滚动 */
  body {
    -webkit-overflow-scrolling: touch;
  }
}
</style>
